import { getLeadTracking, LeadTrackingFilters, LeadTrackingItem } from "@/Api/leadTracking";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState, useCallback } from "react";
import { TableData } from "@/App/LeadTracking/Table";
import { LeadTrackingFiltersComponent } from "@/App/LeadTracking/Filters";
import { FileText } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

interface LeadTrackingResponse {
  data: LeadTrackingItem[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export const PageList = () => {
  const [listData, setListData] = useState<LeadTrackingResponse>({
    data: [],
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  });
  const [state, setState] = useState("loading");
  const [currentFilters, setCurrentFilters] = useState<LeadTrackingFilters>({});

  const fetchData = useCallback(async (filters: LeadTrackingFilters = {}) => {
    setState("loading");
    try {
      const { data } = await getLeadTracking(filters);
      if (data?.response) {
        setListData(data.response);
      }
    } catch (error) {
      console.error("Error fetching lead tracking:", error);
    } finally {
      setState("production");
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = (filters: LeadTrackingFilters) => {
    setCurrentFilters(filters);
    fetchData({ ...filters, page: 1 });
  };

  const pageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        fetchData({ ...currentFilters, page: listData.current_page + 1 });
      }
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        fetchData({ ...currentFilters, page: listData.current_page - 1 });
      }
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        fetchData({ ...currentFilters, page: listData.last_page });
      }
    },
  };

  return (
    <Main>
      <PageHeader
        icon={FileText}
        title="Rastreio de Leads"
        description="Acompanhe os leads cadastrados"
      />
      <div className="flex flex-col gap-3">
        <LeadTrackingFiltersComponent
          onFilter={handleFilter}
          loading={state === "loading"}
        />
        {state === "loading" ? (
          <CreateLoaderTable cols={7} lines={6} />
        ) : (
          <TableData dataApi={listData} pageActions={pageActions} />
        )}
      </div>
    </Main>
  );
};
